import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/orders/")({
  head: () => ({
    meta: [{ title: "订单管理 · imiker CRM" }],
  })
});
